import { render, staticRenderFns } from "./isBlack.vue?vue&type=template&id=cff0d05e"
import script from "./isBlack.vue?vue&type=script&lang=js"
export * from "./isBlack.vue?vue&type=script&lang=js"
import style0 from "./isBlack.vue?vue&type=style&index=0&id=cff0d05e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports